import React from "react";

import { ReactComponent as HailMaryIcon } from "../assets/wordmark-hail-mary.svg";
import { SpiceIcon } from "./SpiceIcon";
import { entryForLevel, type SpiceLevel } from "../util/constants";

import * as styles from "./MysteryMultiHeader.module.scss";

type MysteryMultiHeaderProps = {
  level: SpiceLevel | null;
};

const MysteryMultiHeader = ({ level }: MysteryMultiHeaderProps) => {
  return (
    <div className={styles.header}>
      <HailMaryIcon className={styles.wordmark} aria-hidden />

      {level != null && (
        <div className={styles.level}>
          <SpiceIcon level={level} className={styles.art} aria-hidden />
          <span className={styles.label}>{entryForLevel(level).label}</span>
        </div>
      )}
    </div>
  );
};

export { MysteryMultiHeader };
